import api from '../utils/request';
import { extractErrorMessage } from '../utils/apiErrorHandler';

class AuthAPI {
  async register(userData) {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '注册失败');
    }
  }
  async login(loginData) {
    try {
      const response = await api.post('/auth/login', loginData);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '登录失败');
    }
  }

  async logout() {
    try {
      const response = await api.post('/auth/logout');
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '登出失败');
    }
  }

  async sendVerificationCode(data) {
    try {
      const response = await api.post('/auth/send-verification-code', data);
      return { success: true, message: '验证码发送成功' };
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '验证码发送失败，请稍后重试');
    }
  }

  async sendForgetPassword(data) {
    try {
      const response = await api.post('/auth/send-forget-password', data);
      return response.data || { success: true, message: '重置请求已发送' };
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '发送失败，请稍后重试');
    }
  }

  async changePassword(passwordData) {
    try {
      const response = await api.post('/auth/change-password', passwordData);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '修改密码失败');
    }
  }


}

const authApi = new AuthAPI();
export default authApi;
